import { getDetailsCount, getNumberOfResultsString } from '../utils/search';

function renderResultImage(result) {
  if (result.image === null) {
    return '';
  }

  return `
    <div class="placeholder-background placeholder-background--animation" data-image-placeholder aria-hidden="true"></div>
    <img class="predictive-search-item__image lazyload"
      src="${result.image.url}"
      data-src="${result.image.url}"
      data-image
      alt="${result.image.alt}"
    />
  `;
}

export default function(result, index, resultsCount) {
  let localeInUrl = '';
  if (window.currentLocale !== window.defaultLocale) {
    localeInUrl = `/${window.currentLocale}`;
  }
  return `
    <li id="search-result-${index}" class="predictive-search-item" role="option" data-search-result>
      <a class="predictive-search-item__link" href="${localeInUrl}${result.url}" tabindex="-1">
        <div class="predictive-search__column predictive-search__column--image" data-image-with-placeholder-wrapper>
          ${renderResultImage(result)}
        </div>
        <div class="predictive-search__column predictive-search__column--content ${
          getDetailsCount() ? '' : 'predictive-search__column--center'
        }">
          <span class="predictive-search-item__title">
            <span class="predictive-search-item__title-text">${result.title}</span>
          </span>
          <span class="vh">, </span>
          <span class="vh">${getNumberOfResultsString(index + 1, resultsCount)}</span>
        </div>
      </a>
    </li>
  `;
}
